// Runtime configuration loader
// In per-org deployments, config is injected via window.__RUNTIME_CONFIG__
// by the nginx entrypoint script at container startup.
// Falls back to Vite build-time env vars for local development.

interface RuntimeConfig {
  apiUrl: string
  auth0Domain: string
  auth0ClientId: string
  auth0Audience: string
  disableAuth: boolean
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>
  }
}

function getConfig(): RuntimeConfig {
  const runtime = window.__RUNTIME_CONFIG__ || {}

  return {
    apiUrl: runtime.apiUrl || import.meta.env.VITE_API_URL || '/api',
    auth0Domain: runtime.auth0Domain || import.meta.env.VITE_AUTH0_DOMAIN || '',
    auth0ClientId: runtime.auth0ClientId || import.meta.env.VITE_AUTH0_CLIENT_ID || '',
    auth0Audience: runtime.auth0Audience || import.meta.env.VITE_AUTH0_AUDIENCE || '',
    disableAuth: runtime.disableAuth ?? (import.meta.env.VITE_DISABLE_AUTH === 'true'),
  }
}

export const config = getConfig()
